import { render, staticRenderFns } from "./ProductOrders.vue?vue&type=template&id=1f3f462a&scoped=true&"
import script from "./ProductOrders.vue?vue&type=script&lang=js&"
export * from "./ProductOrders.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrders.vue?vue&type=style&index=0&id=1f3f462a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3f462a",
  null
  
)

export default component.exports